import { useEffect, useRef, useState } from 'react';
import { accessJsonAttr } from '../../utils/utils';
import { MgpAutocompleteProps } from './MgpAutocomplete.types';
import { IOption } from '../../context/model';

function useOutsideAlerter(ref: any,  outsideAction: () => void) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          outsideAction();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }


export default function MgpAutocomplete({id, label, labelFontWeight, options, register, required, errors = {}, onDataSelect, ...props }: MgpAutocompleteProps)  {

    const [searchQuery, setSearchQuery] = useState(props.value);
    const [filteredOptions, setFilteredOptions] = useState<IOption[]>([]);
    const selectBoxRef = useRef(null);


    let labelClassName = "text fw-" + (labelFontWeight ? labelFontWeight: "medium");
    let inputClassName = "form-control";

    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
            inputClassName += " form-error";
          labelClassName += " form-error";
        }
    };

    const onChangeEvent = (event: any) => {  
        const query = event.target.value;
        setSearchQuery(query);
        if (query) {  
            const filtered = options.filter(option => option.label.toLowerCase().includes(query.toLowerCase()) || option.code.includes(query));
            setFilteredOptions(filtered)
        } else {
            setFilteredOptions([])
        }

    }

    const handleClickOption = (option: IOption) => {
        setFilteredOptions([]);
        onDataSelect(option);
        setSearchQuery(`${option.code} - ${option.label}`)
    };

    const closeDropDown = () => {
        setFilteredOptions([]);
    };

    useOutsideAlerter(selectBoxRef, closeDropDown);

    return (
        <>
            {label&&<label className={labelClassName} htmlFor={id}>{label}{required ? <span className='fushia'> (*)</span>: ''}</label>}
            <div style={{marginBottom: "80px"}}>
              <input type='text' autoComplete="off" placeholder="Rechercher votre département" spellCheck={false} className={inputClassName} id={id} {...register(id)} value={searchQuery} {...register(id, {onChange: (e) => {onChangeEvent(e)}})} {...props} />

              {filteredOptions.length > 0 && (
                  <ul ref={selectBoxRef}>
                  {filteredOptions.map((option) => (
                      <li key={option.code} onClick={() => handleClickOption(option)} className="text">{option.code} - {option.label}</li>
                  ))}
                  </ul>
              )}
            </div>  
            {fieldError && (<p className="error">{fieldError.message}</p>)}
        </>
  )
}
